import { UserRole } from '../entities';

export interface UsersPageParams {
    page?: number;
    size?: number;
    role?: UserRole;
    email?: string;
    createdBy?: number;
    teamLeadId?: number;
}
